import { render } from "./PurchaseList.vue?vue&type=template&id=62e79034&scoped=true"
import script from "./PurchaseList.vue?vue&type=script&lang=js"
export * from "./PurchaseList.vue?vue&type=script&lang=js"

import "./PurchaseList.vue?vue&type=style&index=0&id=62e79034&scoped=true&lang=css"
import "./PurchaseList.vue?vue&type=style&index=1&id=62e79034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e79034"]])

export default __exports__